import { api } from './api';

export type AiResultKind = 'qa' | 'audit' | 'forecast' | 'board_pack';

export interface AiResultLite {
  id: string;
  workspaceId: string;
  kind: AiResultKind;
  title: string | null;
  citations: number;
  costCents: number | null;
  pinned: boolean;
  createdAt: string;
}

export interface AiResultFull extends AiResultLite {
  input: Record<string, unknown>;
  output: Record<string, unknown>;
  citedFactIds: string[];
}

export const aiResultsApi = {
  async list(
    workspaceId: string,
    params: { kind?: AiResultKind; pinned?: boolean; limit?: number } = {},
  ): Promise<AiResultLite[]> {
    const r = await api.get<AiResultLite[]>(`/api/workspaces/${workspaceId}/ai-results`, {
      params: {
        kind: params.kind,
        pinned: params.pinned ? 'true' : undefined,
        limit: params.limit,
      },
    });
    return r.data;
  },
  async get(id: string): Promise<AiResultFull> {
    const r = await api.get<AiResultFull>(`/api/ai-results/${id}`);
    return r.data;
  },
  async pin(id: string, pinned: boolean): Promise<AiResultFull> {
    const r = await api.post<AiResultFull>(`/api/ai-results/${id}/pin`, { pinned });
    return r.data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/api/ai-results/${id}`);
  },
};
